<template>
  <div
    class="schedule-prescription-item"
    @click="details = !details">
    <div class="schedule-prescription-details-button">
      <i :class="'fas fa-angle-' + (details ? 'up' : 'down')"></i>
    </div>

    <div>
      <div class="schedule-prescription-drug">
        {{item.drug.name}}

        <small>
          {{ item.drug.measure }}
          {{ item.drug.measureUnit }}
        </small>
      </div>

      <div class="schedule-prescription-quantity">
        {{item.quantity}}
        {{ declensionNumbers(item.quantity, item.drug.format.name) }}
      </div>
    </div>

    <div class="schedule-prescription-details" v-show="details">
      <div class="schedule-prescription-comment">
        {{ item.comment }}
      </div>

      <div
        class="schedule-prescription-days-left"
        v-if="item.startedAt !== null">

        <div v-if="durationLeft > 0">
          Осталось
          <strong>{{ durationLeft }}</strong>
          {{declensionNumbers(durationLeft, 'день')}}
        </div>

        <div v-else-if="durationLeft === 0">
          Последний день приема
        </div>

        <div v-else>
          Прием окончен
        </div>
      </div>

      <div class="schedule-prescription-drug-description">
        {{ item.drug.description }}
      </div>
    </div>
  </div>
</template>

<script>
  import calculateDaysCount from '../../utils/calculateDaysCount';
  import declensionNumbers from '../../utils/declensionNumbers';
  import {FORMAT_NAMES} from '../../constants';

  export default {
    name: 'ScheduleItem',

    props: ['item', 'date'],

    data() {
      return {
        details: false,
      };
    },

    computed: {
      durationLeft() {
        if (this.item.startedAt === null) {
          return 0;
        }

        const daysPrescribed = calculateDaysCount(this.item.startDate, this.item.finishDate);
        const daysInProgress = calculateDaysCount(this.item.startedAt, this.date.getTime());

        return Math.ceil(daysPrescribed - daysInProgress);
      },
    },

    methods: {
      declensionNumbers(count, name) {
        const formatName = FORMAT_NAMES.find(item => item[0] === name);
        const [, few, one, two ] = formatName || [name, name, name, name];

        return declensionNumbers(count, few, one, two);
      },
    }
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .schedule-prescription-item {
    position: relative;
    padding: 10px 0 10px 40px;
    font-size: 12px;
    border-top: 1px solid $light-gray;

    &:first-of-type {
      border-top: 0;
    }

    .schedule-prescription-drug {
      font-weight: bold;
    }

    .schedule-prescription-quantity {
      font-size: 12px;
      color: $primary;
    }

    .schedule-prescription-details-button {
      position: absolute;
      left: 15px;
      top: 20px;
      height: 10px;
      color: $primary;
    }

    .schedule-prescription-start-button {
      position: absolute;
      right: 15px;
      top: 15px;
      padding: 5px 10px;
      font-size: 12px;
      background: $secondary;
      border-radius: 15px;
    }

    .schedule-prescription-details {
      padding-top: 10px;
    }

    .schedule-prescription-days-left {
      font-size: 12px;
      text-transform: uppercase;
      color: $primary;
    }

    .schedule-prescription-drug-description,
    .schedule-prescription-comment {
      font-size: 12px;
    }
  }
</style>
